export default "__VITE_ASSET__CxTj8_1Y__"